export const getButtonColor = (valor: number) => {
    let color;

    // Gradiente para notas baixas (1-3)
    if (valor <= 3) {
        const red = 255; // Vermelho forte
        const green = Math.floor((valor - 1) * (69 / 2)); // Aumenta o verde progressivamente
        color = `rgb(${red}, ${green}, 0)`;
    }
    // Gradiente para notas médias (4-7)
    else if (valor <= 7) {
        const red = Math.floor(255 - (valor - 4) * (114 / 3)); // Reduz o vermelho progressivamente
        const green = 193; // Amarelo forte
        color = `rgb(${red}, ${green}, 0)`;
    }
    // Gradiente para notas altas (8-10)
    else {
        const red = Math.floor(100 - (valor - 8) * (50 / 2)); // Vermelho reduz suavemente
        const green = Math.floor(200 + (valor - 8) * (30 / 2)); // Verde aumenta gradualmente
        color = `rgb(${red}, ${green}, 50)`; // Verde com um pouco de azul para suavizar
    }

    return `rgba(${color.replace("rgb(", "").replace(")", "")})`;
};